import React from 'react'
import { Badge, BadgeProps } from '@/components/ui/badge'

const statusStyles = {
  connected: {
    text: 'text-emerald-500',
    dotSolid: 'bg-emerald-300',
    dotTransparent: 'bg-emerald-50',
    label: 'Connected',
  },
  disconnected: {
    text: 'text-red-500',
    dotSolid: 'bg-red-300',
    dotTransparent: 'bg-red-50',
    label: 'Disconnected',
  },
  pending: {
    text: 'text-yellow-500',
    dotSolid: 'bg-yellow-300',
    dotTransparent: 'bg-yellow-50',
    label: 'Pending',
  },
}

type StatusType = keyof typeof statusStyles

interface StatusBadgeProps extends BadgeProps {
  status?: StatusType
  label?: string
}

const StatusBadge: React.FC<StatusBadgeProps> = ({ status = 'pending', label, className = '', ...props }) => {
  const style = statusStyles[status]
  return (
    <Badge
      {...props}
      variant="outline"
      className={`flex items-center gap-2 text-xs ${style.text} ${className}`}
      data-testid="status-badge"
    >
      <div className="relative flex items-center justify-center">
        <div className={`w-3 h-3 rounded-full ${style.dotTransparent}`}></div>
        <div className={`absolute w-2 h-2 rounded-full ${style.dotSolid}`}></div>
      </div>
      {label || style.label}
    </Badge>
  )
}

export default StatusBadge
